function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import React from 'react';
import classnames from 'classnames';
import { getPathValue } from './utils';
import ComparisonViewContext from './comparison-view-context';
// tslint:disable-next-line:function-name
function RowGroup(props) {
  var _row$title, _ref, _row$key, _row$align;
  var row = props.row,
    dataSource = props.dataSource,
    getColKey = props.getColKey,
    getColClassName = props.getColClassName,
    groupIndex = props.index,
    onColMouseEnter = props.onColMouseEnter,
    onColMouseLeave = props.onColMouseLeave;
  var dataIndex = row.dataIndex,
    render = row.render;
  var _React$useContext = React.useContext(ComparisonViewContext),
    currentHoveringColIndex = _React$useContext.currentHoveringColIndex;
  var title = (_row$title = row.title) !== null && _row$title !== void 0 ? _row$title : row.key;
  var rowKey = (_ref = (_row$key = row.key) !== null && _row$key !== void 0 ? _row$key : dataIndex === null || dataIndex === void 0 ? void 0 : dataIndex.toString()) !== null && _ref !== void 0 ? _ref : groupIndex;
  var contentAlignClassName = "content-align-".concat((_row$align = row.align) !== null && _row$align !== void 0 ? _row$align : 'left');
  return /*#__PURE__*/React.createElement("div", {
    className: classnames('comparison-view-row', row.className, _defineProperty(_defineProperty({}, 'comparison-view-header-row', row.__isHeaderRow), 'comparison-view-footer-row', row.__isFooterRow))
  }, /*#__PURE__*/React.createElement("div", {
    "data-row-key": rowKey,
    className: classnames('comparison-view-row-cell', 'comparison-view-row-label')
  }, title), dataSource.map(function (record, recordIdx) {
    var _getColKey;
    var key = (_getColKey = getColKey(record, recordIdx)) !== null && _getColKey !== void 0 ? _getColKey : recordIdx;
    var value = !dataIndex ? null : getPathValue(record, dataIndex);
    var colClassName = getColClassName(record, recordIdx, groupIndex);
    return /*#__PURE__*/React.createElement("div", {
      key: key,
      "data-row-key": rowKey,
      "data-col-key": key,
      className: classnames('comparison-view-row-cell', colClassName, _defineProperty({}, 'col-hover-active', currentHoveringColIndex === recordIdx)),
      onMouseEnter: function onMouseEnter(ev) {
        return onColMouseEnter(ev, record, recordIdx);
      },
      onMouseLeave: function onMouseLeave(ev) {
        return onColMouseLeave(ev, record, recordIdx);
      }
    }, /*#__PURE__*/React.createElement("div", {
      className: classnames('comparison-view-row-cell-content', contentAlignClassName)
    }, render ? render(value, record, recordIdx) : value));
  }));
}
export default RowGroup;